import { useCallback, useState } from "react";
import { useSearchParams } from "react-router";
import { CheckValue } from "../../../../../../Service/service";

export const useCampusViewState = (setAction) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const [droneNest, setDroneNest] = useState(() => {
    return searchParams.get("drone_nest") || null;
  });

  const [show, setShow] = useState(() => {
    const view = searchParams.get("view");
    return CheckValue(view) &&
      ["Available", "Unavailable", "Doors", "drone_nest","Unassigned Drones","Unassigned Doors"].includes(view)
      ? view
      : null;
  });

  const toggleView = useCallback(
    (keyName, value) => {
      const params = new URLSearchParams(searchParams.toString());

      if (CheckValue(value)) {
        params.set(keyName, value);
      } else {
        params.delete(keyName);
      }

      if (value === "drone_nest") {
        params.set("drone_nest", droneNest);
      } else {
        params.delete("drone_nest");
      }

      setSearchParams(params);
    },
    [searchParams, droneNest, setSearchParams],
  );

  return {
    show,
    setShow,
    droneNest,
    setDroneNest,
    toggleView,
  };
};